import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    exports: [MatIconModule, MatButtonModule, MatProgressSpinnerModule, MatTabsModule, MatDialogModule],
})
export class PaymentMethodsMaterialModule {}
